import { supabase } from '../services/supabaseService';

const useAuth = () => {
  const signInWithEmail = async (email) => {
    try {
      const { error } = await supabase.auth.signInWithOtp({
        email,
        options: {
          emailRedirectTo: window.location.origin,
        },
      });

      if (error) throw error;
      return { success: true };
    } catch (error) {
      console.error('Error sending verification email:', error.message);
      return { success: false, error: error.message };
    }
  };

  const verifyOTP = async (email, token) => {
    try {
      const { data, error } = await supabase.auth.verifyOtp({
        email,
        token,
        type: 'email',
      });

      if (error) throw error;
      return { success: true, data };
    } catch (error) {
      console.error('Error verifying OTP:', error.message);
      return { success: false, error: error.message };
    }
  };

  const signOut = async () => {
    try {
      const { error } = await supabase.auth.signOut();
      if (error) throw error;
      return { success: true };
    } catch (error) {
      console.error('Error signing out:', error.message);
      return { success: false, error: error.message };
    }
  };

  const getCurrentUser = async () => {
    try {
      const { data: { user }, error } = await supabase.auth.getUser();
      if (error) throw error;
      return { success: true, user };
    } catch (error) {
      console.error('Error getting current user:', error.message);
      return { success: false, error: error.message };
    }
  };

  return {
    signInWithEmail,
    verifyOTP,
    signOut,
    getCurrentUser,
  };
};

export default useAuth;